/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setRotation, setZoom } from "../store/slice/centerGraphSlice";
import { setRotationGraphCompare, setZoomGraphCompare } from "../store/slice/roomSlices/exploreRoomSlice";
import store from "../store/store"

export const handleSetRotation = (callback) => {
    let rotation = {};
    Object.assign(rotation, store.getState().centerGraph.position.rotation);

    rotation = callback(rotation);

    store.dispatch(setRotation(rotation));
}

export const handleSetZoom = (callback) => {
    let scale = store.getState().centerGraph.position.scale;

    scale = callback(scale);

    store.dispatch(setZoom(scale));
}

export const handleSetRotationGraphCompare = (callback) => {
    store.dispatch(setRotationGraphCompare(callback));
}

export const handleSetZoomGraphCompare = (callback) => {
    store.dispatch(setZoomGraphCompare(callback));
}